import * as React from "react";

import { Client } from "../../../../../domain/model/client";
import { Company } from "../../../../../domain/model/company";

import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import { clientConfig } from "../../../../../config/language/ja-JP/domain/model_text";
import { ConstColor } from "../../../../../config/styles_const/styles_const";
import Table from "../../../../common/atom/table/table";
import Tbody from "../../../../common/atom/table/tbody";
import TdWithText from "../../../../common/atom/table/td_with_text";
import ThWithText from "../../../../common/atom/table/th_with_text";
import Tr from "../../../../common/atom/table/tr";
import ParagraphSup from "../../../../common/atom/text/paragraph_sup";
import ProfileRightBtnWrapper from "../../../../common/atom/wrapper/profile_right_btn_wrapper";
import ClientProfile from "../../../../common/organism/client_profile";

interface IProps {
  client: Client | null;
  company: Company | null;
}

export const ClientMypageInfoClientMain: React.FC<IProps> = (props) => {
  const { client, company } = props;

  if (!client || !company) {
    return <div />;
  }

  let res: JSX.Element;

  // 通常ページ
  res = (
    <React.Fragment>
      <ClientProfile client={client} company={company} />

      <RightParagraphSup>※プロからは電話番号は見えません</RightParagraphSup>
      <ProfileRightBtnWrapper>
        <EditLink to={"/client/mypage/client/_edit"}>編集する</EditLink>
      </ProfileRightBtnWrapper>
      <Table>
        <Tbody>
          <Tr>
            <ThWithText>{clientConfig.name}</ThWithText>
            <TdWithText colSpan={3}>{client.name}</TdWithText>
          </Tr>
          <Tr>
            <ThWithText>{clientConfig.nameKana}</ThWithText>
            <TdWithText colSpan={3}>{client.nameKana}</TdWithText>
          </Tr>
          <Tr>
            <ThWithText>{"部署"}</ThWithText>
            <TdWithText colSpan={3}>{client.department}</TdWithText>
          </Tr>
          <Tr>
            <ThWithText>{clientConfig.position}</ThWithText>
            <TdWithText colSpan={3}>{client.position}</TdWithText>
          </Tr>
          <Tr>
            <ThWithText>{clientConfig.phoneNumber}</ThWithText>
            <TdWithText colSpan={3}>{client.phoneNumber}</TdWithText>
          </Tr>
        </Tbody>
      </Table>
    </React.Fragment>
  );

  return res;
};

export default ClientMypageInfoClientMain;

const RightParagraphSup = styled(ParagraphSup)`
  text-align: right;
  color: ${ConstColor.Error};
`;

const EditLink = styled(GoldLink)`
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/info_client/client_mypage_info_client_main.tsx